import { API } from '@Providers';

export default async function (personId: string) {
  const endpoint = `/api/shelter/people/opt-ins/${personId}`;

  return API({ endpoint });
}
